export const FETCH_USER_DETAILS = 'FETCH_USER_DETAILS'
export const FETCH_USER_METADATA = 'FETCH_USER_METADATA'
export const FETCH_USER_PHOTO = 'FETCH_USER_PHOTO'

// Search queries
export const FETCH_SUGGESTED_PROMPTS = 'FETCH_SUGGESTED_PROMPTS'
export const FETCH_COUNTRIES_AND_HAZARDS = 'FETCH_COUNTRIES_AND_HAZARDS'
//Landing page queries
export const FETCH_MOTIVATIONS = 'FETCH_MOTIVATIONS'

// Spaces queries
export const FETCH_CONVERSATIONS = 'FETCH_CONVERSATIONS'
export const FETCH_REPORTS = 'FETCH_REPORTS'
export const FETCH_REPORT_BY_ID = 'FETCH_REPORT_BY_ID'

// Explorer queries
export const FETCH_EXPLORER_HAZARD_LAYERS = 'FETCH_EXPLORER_HAZARD_LAYERS'

//Conversation
export const FETCH_CONVERSATION_BY_ID = 'FETCH_CONVERSATION_BY_ID'

//Dashboard queries
export const FETCH_PROJECT_DOCUMENTS_BY_HAZARD_TYPE = 'FETCH_PROJECT_DOCUMENTS_BY_HAZARD_TYPE'
export const FETCH_PUBLICATIONS_BY_HAZARD_TYPE = 'FETCH_PUBLICATIONS_BY_HAZARD_TYPE'
export const FETCH_NEWS_INSIGHTS_BY_HAZARD_TYPE = 'FETCH_NEWS_INSIGHTS_BY_HAZARD_TYPE'
